import {Header} from "@/components/Header";
import {Modal} from "@/components/Modal";
import {IoMdClose} from "react-icons/io";
import {useState} from "react";

const PresidentsThoughts = () => {
	const [isModalOpen, setModalOpen] = useState(false);
	const [selectedVideo, setSelectedVideo] = useState({title: "", url: ""});

	const openModal = (video) => {
		if (video.url) {
			setSelectedVideo(video);
			setModalOpen(true);
		} else {
			alert("Video not available");
		}
	};

	const closeModal = () => {
		setModalOpen(false);
		setSelectedVideo({title: "", url: ""});
	};

	const ytLink = [
		{
			title: "अध्यक्षांचे मनोगत",
			img: "/kulvratant_landingPage/video-thumbnail.png",
			url: "https://www.youtube.com/embed/DRmHbInoFUQ",
		},
	];

	return (
		<>
			<div className="w-full flex flex-col items-center justify-center">
				<Header/>
				<div className="mt-40">
					{ytLink.map((data, index) => (
						<div
							key={index}
							onClick={() => openModal(data)}
							className="cursor-pointer"
						>
							<div className="flex items-center justify-center flex-col">
								<img
									src={data.img}
									alt={data.title}
									className="w-[700px]"
								/>
								<h3 className="text-3xl font-custom-mono-bold-italic">
									{data.title}
								</h3>
							</div>
						</div>
					))}
				</div>
			</div>

			{/* Modal */}
			<Modal isOpen={isModalOpen} onClose={closeModal}>
				<div className="relative w-full h-full p-4 bg-white rounded-lg">
					<button
						className="absolute top-2 right-2 text-gray-700 rounded-full p-2 shadow-md"
						onClick={closeModal}
					>
						<IoMdClose/>
					</button>
					<h2 className="text-center text-2xl font-custom-bold text-red-600 mb-4">
						{selectedVideo.title}
					</h2>
					{selectedVideo.url ? (
						<iframe
							width="100%"
							height="350"
							src={selectedVideo.url}
							title="YouTube video"
							frameBorder="0"
							className="rounded-lg"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
							allowFullScreen
						></iframe>
					) : (
						<div className="text-center text-lg custom-semi-bold">
							Video not available
						</div>
					)}
				</div>
			</Modal>
		</>
	);
};

export default PresidentsThoughts;
